'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$() {
  this.Lapp_data_types\uff3fadmin$package$AdminAuditLogId$__f_defaultMake$lzy1 = null;
  this.Lapp_data_types\uff3fadmin$package$AdminAuditLogId$__f_defaultMakebitmap$1 = false;
  this.Lapp_data_types\uff3fadmin$package$AdminAuditLogId$__f_make$lzy1 = null;
  this.Lapp_data_types\uff3fadmin$package$AdminAuditLogId$__f_makebitmap$1 = false;
  this.Lapp_data_types\uff3fadmin$package$AdminAuditLogId$__f_given_CanEqual1_Type$lzy1 = null;
  this.Lapp_data_types\uff3fadmin$package$AdminAuditLogId$__f_given_CanEqual1_Typebitmap$1 = false;
  this.Lapp_data_types\uff3fadmin$package$AdminAuditLogId$__f_schema$lzy3 = null;
  this.Lapp_data_types\uff3fadmin$package$AdminAuditLogId$__f_schemabitmap$3 = false;
}
export { $c_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$ as $c_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$ };
$c_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$.prototype.constructor = $c_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$;
/** @constructor */
function $h_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$() {
}
export { $h_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$ as $h_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$ };
$h_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$.prototype = $c_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$.prototype;
$c_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$.prototype.defaultMake__Lyantl_INewtype$defaultMake$ = (function() {
  if ((!this.Lapp_data_types\uff3fadmin$package$AdminAuditLogId$__f_defaultMakebitmap$1)) {
    this.Lapp_data_types\uff3fadmin$package$AdminAuditLogId$__f_defaultMake$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$defaultMake$(this);
    this.Lapp_data_types\uff3fadmin$package$AdminAuditLogId$__f_defaultMakebitmap$1 = true;
  }
  return this.Lapp_data_types\uff3fadmin$package$AdminAuditLogId$__f_defaultMake$lzy1;
});
$c_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$.prototype.make__Lyantl_INewtype$make$ = (function() {
  if ((!this.Lapp_data_types\uff3fadmin$package$AdminAuditLogId$__f_makebitmap$1)) {
    this.Lapp_data_types\uff3fadmin$package$AdminAuditLogId$__f_make$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$make$(this);
    this.Lapp_data_types\uff3fadmin$package$AdminAuditLogId$__f_makebitmap$1 = true;
  }
  return this.Lapp_data_types\uff3fadmin$package$AdminAuditLogId$__f_make$lzy1;
});
$c_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$.prototype.resolveMake__Lyantl_Make = (function() {
  return this.defaultMake__Lyantl_INewtype$defaultMake$();
});
$c_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$.prototype.protected_unwrap__O__O = (function(wrapped) {
  return wrapped;
});
$c_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$.prototype.wrap__O__O = (function(underlying) {
  return underlying;
});
$c_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$.prototype.validate__Lyantl_Validate = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lyantl_Validate$().Lyantl_Validate$__f_noOp;
});
$c_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$.prototype.given_CanEqual1_Type__s_CanEqual = (function() {
  if ((!this.Lapp_data_types\uff3fadmin$package$AdminAuditLogId$__f_given_CanEqual1_Typebitmap$1)) {
    this.Lapp_data_types\uff3fadmin$package$AdminAuditLogId$__f_given_CanEqual1_Type$lzy1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_CanEqual$derived$();
    this.Lapp_data_types\uff3fadmin$package$AdminAuditLogId$__f_given_CanEqual1_Typebitmap$1 = true;
  }
  return this.Lapp_data_types\uff3fadmin$package$AdminAuditLogId$__f_given_CanEqual1_Type$lzy1;
});
$c_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$.prototype.schema__Lsttp_tapir_Schema = (function() {
  if ((!this.Lapp_data_types\uff3fadmin$package$AdminAuditLogId$__f_schemabitmap$3)) {
    this.Lapp_data_types\uff3fadmin$package$AdminAuditLogId$__f_schema$lzy3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_Base64Id$().schemaFor__Lsttp_tapir_Schema();
    this.Lapp_data_types\uff3fadmin$package$AdminAuditLogId$__f_schemabitmap$3 = true;
  }
  return this.Lapp_data_types\uff3fadmin$package$AdminAuditLogId$__f_schema$lzy3;
});
var $d_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$, "app.data.types_admin$package$AdminAuditLogId$", ({
  Lapp_data_types\uff3fadmin$package$AdminAuditLogId$: 1,
  Lyantl_INewtype: 1,
  Lyantl_Newtype: 1,
  Lyantl_Newtype$Of: 1,
  Lyantl_Newtype$WithoutValidation: 1,
  Lyantl_Newtype$WithoutValidationOf: 1,
  Lframework_utils_NewtypeULID: 1
}));
export { $d_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$ as $d_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$ };
var $n_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$;
function $m_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$() {
  if ((!$n_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$)) {
    $n_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$ = new $c_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$();
  }
  return $n_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$;
}
export { $m_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$ as $m_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$ };
//# sourceMappingURL=app.data.types_admin$package$-Admin-Audit-Log-Id$.js.map
